import {
    JsonApiModel,
    Attribute,
    JsonApiModelConfig,
    JsonApiDatastore
} from 'angular2-jsonapi'

@JsonApiModelConfig({
    type: 'operadoras-de-maquina'
})
export class OperadoraDeMaquina extends JsonApiModel {
    @Attribute() cnpj: string
    @Attribute() nome: string
    @Attribute() codename: string
    @Attribute() antecipa: boolean
    @Attribute() informaLiquido: boolean
    @Attribute() numeraEstabelecimento: boolean
    @Attribute() limiteParaSincronizaremMeses: number
    @Attribute() robo: string
    @Attribute() disponivel: boolean
    @Attribute() novaOperadora: boolean
    @Attribute() ativo: boolean
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/collect/operadora-de-maquina.model.ts